export default __webpack_public_path__ + "static/media/logo-wht-orng.7b5bf600.png";